export const OFFLINE_ALERT_MESSAGE = 'Oops! You are offline. Please check your internet connection. 🙂'
export const SERVER_UNREACHABLE_MESSAGE =
  'Oops! Unable to reach the server. Please check your internet connection and try again. 🙂'
export const FORCE_INTERNET_CONNECTION = import.meta.env.VITE_FORCE_INTERNET_CONNECTION
